import { useLocation } from 'react-router-dom';

const useCTLocation = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  return { ...location, queryParams };
};

export default useCTLocation;
